import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-094e22be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerar", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "ss-tela-conteudo" }
const _hoisted_10 = { class: "ss-card ss-card-space" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1))
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_16 = {
  key: 0,
  class: "ant-col ant-col-xs-6 ant-col-xl-6"
}
const _hoisted_17 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_19 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = {
  key: 0,
  class: "ant-col ant-col-xs-5 ant-col-xl-5"
}
const _hoisted_31 = {
  key: 1,
  class: "ant-col ant-col-xs-5 ant-col-xl-5"
}
const _hoisted_32 = {
  key: 2,
  class: "ant-col ant-col-xs-5 ant-col-xl-5"
}
const _hoisted_33 = {
  key: 3,
  class: "ant-col ant-col-xs-4 ant-col-xl-4"
}
const _hoisted_34 = {
  key: 0,
  class: "ss-card ss-card-space ss-alinhar-texto-esquerda",
  style: {"min-height":"40%"}
}
const _hoisted_35 = ["title"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = { key: 4 }
const _hoisted_39 = { key: 5 }
const _hoisted_40 = { key: 6 }
const _hoisted_41 = {
  key: 7,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Nº do Título: ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa: ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento: ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Baixa: ", -1))
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor: ", -1))
const _hoisted_49 = {
  key: 8,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa: ", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta: ", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de Documento: ", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento: ", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Baixa: ", -1))
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor: ", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Saldo: ", -1))
const _hoisted_59 = { class: "ant-row" }
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_62 = {
  class: "ant-input-affix-wrapper ss-paginacao-qtde-registros",
  style: {"margin-top":"0px"}
}
const _hoisted_63 = { class: "ant-input-suffix" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1))
const _hoisted_65 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_selecionar_tipo_relatorio_titulos_financeiros = _resolveComponent("selecionar-tipo-relatorio-titulos-financeiros")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_titulo_financeiro = _resolveComponent("selecionar-tipo-titulo-financeiro")!
  const _component_selecionar_tipo_data_titulo_financeiro = _resolveComponent("selecionar-tipo-data-titulo-financeiro")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_selecionar_status_titulo_financeiro = _resolveComponent("selecionar-status-titulo-financeiro")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_totalizador_decorado = _resolveComponent("totalizador-decorado")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_card = _resolveComponent("card")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_titulo_padrao, {
            identificadorRecurso: _ctx.telaBase.identificadorRecurso,
            tituloRecurso: _ctx.telaBase.titulo,
            exibirAtalhosTela: true,
            exibirHistoricoTela: false,
            empresasSelecionadas: [_ctx.state.filtros.empresa]
          }, {
            BotoesAcoes: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.state.mostrarPagar || _ctx.state.mostrarReceber)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Imprimir",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                        }, [
                          _createVNode(_component_icone, { nome: "imprimir" })
                        ]),
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Exportar Word",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                        }, [
                          _createVNode(_component_icone, { nome: "word" })
                        ]),
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Exportar Excel",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                        }, [
                          _createVNode(_component_icone, { nome: "excel" })
                        ]),
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Exportar CSV",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                        }, [
                          _createVNode(_component_icone, { nome: "download-arquivo" })
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-primary ss-btn-tela",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.buscarTitulos && _ctx.buscarTitulos(...args))),
                    disabled: !_ctx.state.mostrarPagar && !_ctx.state.mostrarReceber
                  }, _hoisted_8, 8, _hoisted_6)
                ])
              ])
            ]),
            _: 1
          }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_select, {
                    value: _ctx.state.filtros.empresa,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.filtros.empresa) = $event)),
                    options: _ctx.telaBase.empresasDisponiveis,
                    style: {"width":"100%"},
                    optionFilterProp: "label",
                    onChange: _ctx.atualizarSelecaoEmpresas
                  }, null, 8, ["value", "options", "onChange"])
                ])
              ], 512), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              _createVNode(_component_a_collapse, {
                ghost: "",
                class: "ss-accordion",
                activeKey: _ctx.state.mostrarFiltrosInteligentes,
                "onUpdate:activeKey": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.mostrarFiltrosInteligentes) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    key: "1",
                    header: "FILTROS INTELIGENTES"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.usarFiltroInteligente(1)))
                      }, "Contas a pagar/pagas que vencem no mês"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.usarFiltroInteligente(2)))
                      }, "Contas a receber/recebidas que vencem no mês"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.usarFiltroInteligente(3)))
                      }, "Contas a pagar vencidas no mês"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.usarFiltroInteligente(4)))
                      }, "Contas a receber vencidas no mês"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.usarFiltroInteligente(5)))
                      }, "Contas pagas no mês"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.usarFiltroInteligente(6)))
                      }, "Contas recebidas no mês"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.usarFiltroInteligente(7)))
                      }, "Contas a pagar no próximo mês"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.usarFiltroInteligente(8)))
                      }, "Contas a receber no próximo mês"),
                      (_ctx.state.controleAlcada)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "ant-btn ss-btn-filtro-inteligente",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.usarFiltroInteligente(9)))
                          }, "Despesas pendentes de aprovação"))
                        : _createCommentVNode("", true),
                      (_ctx.state.controleAlcada)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "ant-btn ss-btn-filtro-inteligente",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.usarFiltroInteligente(10)))
                          }, "Despesas reprovadas"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"]),
              _createVNode(_component_a_collapse, {
                ghost: "",
                class: "ss-accordion",
                activeKey: _ctx.state.mostrarFiltros,
                "onUpdate:activeKey": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.mostrarFiltros) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    key: "1",
                    header: "FILTROS PERSONALIZADOS"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form, { layout: "vertical" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_a_form_item, {
                                label: "Variação",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_tipo_relatorio_titulos_financeiros, {
                                    valor: _ctx.state.filtros.tipo,
                                    "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.filtros.tipo) = $event)),
                                    mostrarReceber: _ctx.state.mostrarReceber
                                  }, null, 8, ["valor", "mostrarReceber"])
                                ]),
                                _: 1
                              })
                            ]),
                            ((_ctx.state.mostrarPagar || _ctx.state.mostrarReceber) && _ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.ProjecaoRecebiveis)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Tipo de Título",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_selecionar_tipo_titulo_financeiro, {
                                        mostrarPagar: _ctx.state.mostrarPagar,
                                        mostrarReceber: _ctx.state.mostrarReceber,
                                        valor: _ctx.state.filtros.tipoTitulo,
                                        "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.filtros.tipoTitulo) = $event))
                                      }, null, 8, ["mostrarPagar", "mostrarReceber", "valor"])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_a_form_item, {
                                label: "Tipo de Data",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_tipo_data_titulo_financeiro, {
                                    valor: _ctx.state.filtros.tipoData,
                                    "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.filtros.tipoData) = $event)),
                                    mostrarBaixa: _ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.ProjecaoRecebiveis
                                  }, null, 8, ["valor", "mostrarBaixa"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_a_form_item, {
                                label: "Período",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data_inicial_final, {
                                    dataInicialSelecionada: _ctx.state.dataInicial,
                                    "onUpdate:dataInicialSelecionada": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.dataInicial) = $event)),
                                    dataFinalSelecionada: _ctx.state.dataFinal,
                                    "onUpdate:dataFinalSelecionada": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.dataFinal) = $event))
                                  }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          (_ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.BaixadosContas && _ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.ProjecaoRecebiveis)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Status",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_selecionar_status_titulo_financeiro, {
                                        varios: true,
                                        "controle-alcada": true,
                                        mostrarTodos: true,
                                        empresas: [_ctx.state.filtros.empresa],
                                        valores: _ctx.state.filtros.status,
                                        "onUpdate:valores": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.filtros.status) = $event))
                                      }, null, 8, ["empresas", "valores"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_selecionar_conta, {
                                title: "Contas",
                                varios: true,
                                empresas: [_ctx.state.filtros.empresa],
                                "codigos-selecionados": _ctx.state.filtros.contas,
                                "onUpdate:codigosSelecionados": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.filtros.contas) = $event))
                              }, null, 8, ["empresas", "codigos-selecionados"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_a_form_item, {
                                label: "Pessoas",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_pessoa, {
                                    varios: true,
                                    empresas: [_ctx.state.filtros.empresa],
                                    "codigos-selecionados": _ctx.state.filtros.pessoas,
                                    "onUpdate:codigosSelecionados": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.filtros.pessoas) = $event))
                                  }, null, 8, ["empresas", "codigos-selecionados"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_a_form_item, {
                                label: "Tipos de Documentos",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_tipo_documento_financeiro, {
                                    varios: true,
                                    empresas: [_ctx.state.filtros.empresa],
                                    "codigos-selecionados": _ctx.state.filtros.tiposDocumentos,
                                    "onUpdate:codigosSelecionados": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.filtros.tiposDocumentos) = $event))
                                  }, null, 8, ["empresas", "codigos-selecionados"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_a_form_item, {
                                label: "Categorias",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_categoria_plano_conta, {
                                    empresas: [_ctx.state.filtros.empresa],
                                    "codigos-selecionados": _ctx.state.filtros.categorias,
                                    "onUpdate:codigosSelecionados": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.filtros.categorias) = $event)),
                                    varios: true
                                  }, null, 8, ["empresas", "codigos-selecionados"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"]),
              (_ctx.state.titulos.length > 0)
                ? (_openBlock(), _createBlock(_component_a_collapse, {
                    key: 0,
                    ghost: "",
                    class: "ss-accordion",
                    activeKey: _ctx.state.mostrarTotalizadores,
                    "onUpdate:activeKey": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.mostrarTotalizadores) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse_panel, {
                        key: "1",
                        header: "TOTALIZADORES"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_29, [
                            (_ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.BaixadosContas && _ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.ProjecaoRecebiveis)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createVNode(_component_totalizador_decorado, {
                                    titulo: "TOTAL DE TÍTULOS",
                                    cor: "#424BC6",
                                    iconeColorido: true,
                                    monetario: true,
                                    valor: _ctx.state.resultado.totalTitulos
                                  }, null, 8, ["valor"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.BaixadosContas)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createVNode(_component_totalizador_decorado, {
                                    titulo: "TOTAL PENDENTE",
                                    cor: "#F7E811",
                                    iconeColorido: true,
                                    monetario: true,
                                    valor: _ctx.state.resultado.totalPendente
                                  }, null, 8, ["valor"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.ProjecaoRecebiveis)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createVNode(_component_totalizador_decorado, {
                                    titulo: "TOTAL BAIXADO",
                                    cor: "#8DC642",
                                    iconeColorido: true,
                                    monetario: true,
                                    valor: _ctx.state.resultado.totalPago
                                  }, null, 8, ["valor"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.filtros.tipo !== _ctx.ETipoRelatorioTitulosFinanceiros.BaixadosContas)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createVNode(_component_totalizador_decorado, {
                                    titulo: "TOTAL ATRASADO",
                                    cor: "red",
                                    iconeColorido: true,
                                    monetario: true,
                                    valor: _ctx.state.resultado.totalAtrasado
                                  }, null, 8, ["valor"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["activeKey"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.state.mostrarTitulos)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(_component_card, { titulo: "RESULTADO" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        style: {"margin-bottom":"5px"},
                        columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                        "data-source": _ctx.state.titulos,
                        rowKey: "codigo",
                        pagination: false,
                        loading: _ctx.telaBase.carregando,
                        scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth +150), y: _ctx.window.innerHeight - 345 },
                        size: "small"
                      }, {
                        bodyCell: _withCtx(({ column, record, text }) => [
                          (column.key === 'TipoDocumentoFinanceiro')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                title: record.descricaoTipoDocumentoFinanceiro
                              }, _toDisplayString(record.siglaTipoDocumentoFinanceiro), 9, _hoisted_35))
                            : _createCommentVNode("", true),
                          (column.key === 'DiasAtraso')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(text) + " Dias", 1))
                            : (column.key === 'Status')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  ((record.pessoaRepasse > 0 && record.status === _ctx.EStatusTituloFinanceiro.Pendente || record.status === _ctx.EStatusTituloFinanceiro.BaixadoParcialmente))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_a_tag, {
                                          title: "Baixa Parcial",
                                          class: "ss-tag-status baixado-parcialmente"
                                        }),
                                        _createTextVNode("Baixa Parcial ")
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createVNode(_component_a_tag, {
                                          title: text,
                                          class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(record.descricaoStatus))
                                        }, null, 8, ["title", "class"]),
                                        _createTextVNode(_toDisplayString(text), 1)
                                      ], 64))
                                ], 64))
                              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararTelefoneCelular)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(text)), 1))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2, true, true)), 1))
                                      : (column.key === 'TituloFinanceiro' && _ctx.state.filtrosUtilizados.tipo == _ctx.ETipoRelatorioTitulosFinanceiros.Sintetico)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                            _createElementVNode("span", null, [
                                              _hoisted_42,
                                              _createTextVNode(_toDisplayString(record.numeroTitulo), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_43,
                                              _createTextVNode(_toDisplayString(record.nomePessoa), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_44,
                                              _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimentoFormatada)), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_45,
                                              _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataBaixaFormatada)), 1)
                                            ]),
                                            ((record.pessoaRepasse > 0 && record.status === _ctx.EStatusTituloFinanceiro.Pendente || record.status === _ctx.EStatusTituloFinanceiro.BaixadoParcialmente))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                                  _createVNode(_component_a_tag, {
                                                    title: "Baixa Parcial",
                                                    class: "ss-tag-status baixado"
                                                  }),
                                                  _createTextVNode("Repassado")
                                                ]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                                  _createVNode(_component_a_tag, {
                                                    title: text,
                                                    class: _normalizeClass('ss-tag-status ' + record.descricaoStatus)
                                                  }, null, 8, ["title", "class"]),
                                                  _createTextVNode(_toDisplayString(record.descricaoStatus), 1)
                                                ])),
                                            _createElementVNode("span", null, [
                                              _hoisted_48,
                                              _createTextVNode("R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal,2, true, true)), 1)
                                            ])
                                          ]))
                                        : (column.key === 'TituloFinanceiro' && _ctx.state.filtrosUtilizados.tipo == _ctx.ETipoRelatorioTitulosFinanceiros.Analitico)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _createElementVNode("span", null, [
                                                _hoisted_50,
                                                _createTextVNode(_toDisplayString(record.nomePessoa), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_51,
                                                _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_52,
                                                _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' + record.descricaoTipoDocumentoFinanceiro), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_53,
                                                _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimentoFormatada)), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_54,
                                                _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataBaixaFormatada)), 1)
                                              ]),
                                              ((record.pessoaRepasse > 0 && record.status === _ctx.EStatusTituloFinanceiro.Pendente || record.status === _ctx.EStatusTituloFinanceiro.BaixadoParcialmente))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                                                    _createVNode(_component_a_tag, {
                                                      title: "Repassado",
                                                      class: "ss-tag-status baixado"
                                                    }),
                                                    _createTextVNode("Repassado")
                                                  ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                                    _createVNode(_component_a_tag, {
                                                      title: text,
                                                      class: _normalizeClass('ss-tag-status ' + record.descricaoStatus)
                                                    }, null, 8, ["title", "class"]),
                                                    _createTextVNode(_toDisplayString(record.descricaoStatus), 1)
                                                  ])),
                                              _createElementVNode("span", null, [
                                                _hoisted_57,
                                                _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal,2, true, true)), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_58,
                                                _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo,2, true, true)), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                        ]),
                        emptyText: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, {
                            resultadoPesquisa: !_ctx.telaBase.carregando,
                            mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                          }, null, 8, ["resultadoPesquisa", "mensagem"])
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "loading", "scroll"]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode(_component_a_pagination, {
                            class: "ss-paginacao-completa",
                            current: _ctx.state.paginacao.current,
                            "onUpdate:current": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.paginacao.current) = $event)),
                            size: "small",
                            total: _ctx.state.paginacaoApi.totalRegistros,
                            "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} registros`,
                            "page-size": _ctx.state.paginacao.pageSize,
                            pageSizeOptions: _ctx.state.paginacao.pageSizeOptions,
                            onShowSizeChange: _ctx.onShowSizeChange,
                            showSizeChanger: _ctx.state.paginacao.showSizeChanger,
                            onChange: _ctx.onPageChange
                          }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "showSizeChanger", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("span", _hoisted_62, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.totalRegistrosComMascara) = $event)),
                              onKeyup: _cache[31] || (_cache[31] = ($event: any) => (_ctx.alterarQuantidadeRegistroTotal(($event.target as HTMLInputElement).value))),
                              placeholder: "Total registros",
                              type: "text",
                              class: "ant-input hidden"
                            }, null, 544), [
                              [_vModelText, _ctx.state.totalRegistrosComMascara],
                              [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
                            ]),
                            _createElementVNode("span", _hoisted_63, [
                              _createVNode(_component_a_tooltip, { placement: "top" }, {
                                title: _withCtx(() => [
                                  _hoisted_64
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_65, [
                                    _createVNode(_component_icone, { nome: "informacoes" })
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ], 64))
}